<template>
   <div>
         <v-row justify="center">
               <v-btn rounded class=" button"  @click="openWindow(750,500)">Zoom </v-btn>
         
               <v-btn  rounded class=" button"  @click="openGoToMeeting(750,500)" > GoToMeet</v-btn>
            
               <v-btn  rounded class=" button"  @click="openWindowMeet(750,500)"> Google Meet</v-btn>
          
               <v-btn  rounded class=" button"  @click="openGoToWebinar(750,500)" > GoToWebinar</v-btn>
           
               <v-btn  rounded class=" button"  @click="openGoToTraining(750,500)" > GoToTraining</v-btn>
           
               <v-btn  rounded class=" button"  @click="openWindowTeams(750,500)"> Teams</v-btn>
         </v-row>
   </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
   export default {
       methods: {
                openGoToMeeting(w, h) {
              // alert("openWindow")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               window.open('https://www.gotomeeting.com/en-in', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
                openGoToWebinar(w, h) {
              // alert("openWindow")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               window.open('https://www.gotomeeting.com/en-in/webinar', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
                openGoToTraining(w, h) {
              // alert("openWindow")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               window.open('https://www.gotomeeting.com/en-in/training', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
                openWindow(w, h) {
              // alert("openWindow")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               window.open('https://us04web.zoom.us/signin', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
           openWindowMeet(w, h) {
               //alert("openWindowMeet")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               return window.open('https://meet.google.com/', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
           openWindowTeams(w, h) {
               //alert("openWindowMeet")
               var leftOffset = (screen.width / 2) - w / 2;
               var topOffset = (screen.height / 2) - h / 2;
               return window.open('https://www.microsoft.com/en-in/microsoft-365/microsoft-teams/group-chat-software', this.target, 'left=' + leftOffset + ',top=' + topOffset + ',width=' + w + ',height=' + h + ',resizable,scrollbars=yes');
           },
       }
   }
</script>
<style scoped>
   .row {
   margin: 0.3rem !important;
   padding: 0%;
   }
   .col-mr
   {
   margin: 0% !important;
   padding: 0%;
   margin: 5px;
   }
   .margin-button{
      margin-left: 10px;
   }
   .toolbar
   {
   background-color: #E9AA22 !important;
   color: #ffffff !important;
   }
   .card-border {
   border: 2px solid #424093;
   border-radius: 10px;
   width: auto;
   }
   .pl{
   padding-left: 3rem;
   }
   @media all and (max-width: 900px) {
   .padding-bot {
   padding: 8px;
   }
   .pl{
   padding-left: 0;
   }
   }
</style>